import React, { Component } from 'react'
import { Switch, Route as Routing } from 'react-router-dom';
import Layout from './layout';
import onboardTransporter from '../view/onboardTransporter/onboardTransporter';
import LoginView from '../view/loginView/loginView';
import ApproveRejectForm from '../components/customerComponent/insertTransporter';
import AddFormikTransporter from '../components/customerComponent/registrationForm';
import Settings from '../components/settingComponent/settings';
class Route extends Component {
    render() {
        return (
            <>
                
                    <Switch>
                        {/* <div className=" col-md-8 offset-md-2 w3-card white-bg mt-5 no-margin"> */}
                        <Routing
                            path='/onboard-new-transporter'
                            exact
                            component={AddFormikTransporter}
                        />
                        {/* </div> */}
                        {/* <Path /> */}
                        <Layout>
                        <Routing
                            path='/transporter-onboarding'
                            exact
                            component={onboardTransporter}
                        />
                        <Routing
                            path='/'
                            exact
                            component={LoginView}
                        />

                        <Routing
                            path='/reviewTransporter'
                            exact
                            component={ApproveRejectForm}
                        />
                        <Routing
                            path='/settings'
                            exact
                            component={Settings}
                        />
                        </Layout>
                    </Switch>
                
            </>
        )
    }
}
export default Route
